<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import ImageField from '../ImageField.vue'

const { t } = useI18n()

defineProps<{
  logo: string
  hideTitle?: boolean
}>()

const emit = defineEmits<{
  'update:logo': [value: string]
}>()
</script>

<template>
  <PanelGroup :title="hideTitle ? undefined : t('pages.loyaltySupports.webapp.editor.design.brand.title')">
    <div class="flex flex-col gap-3">
      <label for="brandApp.identity.logo" class="text-sm font-medium">{{
        t('pages.loyaltySupports.webapp.editor.design.brand.logo')
      }}</label>
      <ImageField
        id="brandApp.identity.logo"
        :model-value="logo"
        :aspect-ratio="1"
        crop
        free-crop
        fit="contain"
        :removable="false"
        :help="t('pages.loyaltySupports.webapp.editor.design.brand.logoHelp')"
        @update:model-value="emit('update:logo', $event)"
      />
    </div>
  </PanelGroup>
</template>
